module.exports = __webpack_public_path__ + "img/left_8_hover.6164a9d4.png";